import {IUser } from 'common/interfaces/IUser';

export const getUserDisplayName = (user: IUser): string => {
    if (user) {
        return user.given_name
        ? `${user.given_name} ${user.family_name || ''}`
        : user.preferred_username ? `${user.preferred_username}` : `${user.username}`
    }
	return '';
};